export default function getTotalResa(formulesEleves, elevesList) {

    
    let newList = formulesEleves.filter((formule) => elevesList.find((e) => e.id === formule.id_eleve).checked === true);
    let totalResa = 0;
    //console.log(newList)
    newList.map((f) => {
        totalResa += f.tarif_formule;
    })

    return totalResa;
}